module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-82b1212e.woff";